import TypesList from 'modules/Recommendations/CampaignsRecommendations/TypesList/TypesList'
import Reducer from 'modules/Recommendations/CampaignsRecommendations/TypesList/reducer'
import Sagas from 'modules/Recommendations/CampaignsRecommendations/TypesList/saga'

export default TypesList

export { Sagas, Reducer }
